module.exports = __webpack_public_path__ + "img/f2@2x.987e013c.png";